/**
 * Глобальный менеджер WebSocket соединений
 *
 * Отслеживает все активные WebSocket соединения и позволяет закрывать их все сразу
 * при выходе из системы или отзыве токенов
 */

export class WebSocketManager {
  private connections: Set<{ close: () => void }> = new Set();
  private static instance: WebSocketManager | null = null;

  private constructor() {}

  /**
   * Получить единственный экземпляр менеджера
   */
  static getInstance(): WebSocketManager {
    if (!WebSocketManager.instance) {
      WebSocketManager.instance = new WebSocketManager();
    }
    return WebSocketManager.instance;
  }

  /**
   * Зарегистрировать WebSocket соединение
   */
  register(connection: { close: () => void }): void {
    this.connections.add(connection);
    console.log('[WebSocketManager] Зарегистрировано соединение, всего:', this.connections.size);
  }

  /**
   * Отменить регистрацию WebSocket соединения
   */
  unregister(connection: { close: () => void }): void {
    this.connections.delete(connection);
    console.log('[WebSocketManager] Удалено соединение, осталось:', this.connections.size);
  }

  /**
   * Закрыть все WebSocket соединения
   * Используется при выходе из системы или отзыве токенов
   */
  closeAll(): void {
    console.log('[WebSocketManager] Закрытие всех WebSocket соединений:', this.connections.size);

    // Создаем копию Set чтобы избежать проблем при изменении во время итерации
    const connectionsArray = Array.from(this.connections);

    connectionsArray.forEach((connection) => {
      try {
        connection.close();
      } catch (error) {
        console.warn('[WebSocketManager] Ошибка при закрытии соединения:', error);
      }
    });

    // Очищаем список после закрытия всех соединений
    this.connections.clear();
  }

  /**
   * Получить количество активных соединений
   */
  getConnectionCount(): number {
    return this.connections.size;
  }
}

// Экспортируем единственный экземпляр
export default WebSocketManager.getInstance();
